import { render, staticRenderFns } from "./TRLExplainer.vue?vue&type=template&id=136ba2c4&"
import script from "./TRLExplainer.vue?vue&type=script&lang=js&"
export * from "./TRLExplainer.vue?vue&type=script&lang=js&"
import style0 from "./TRLExplainer.vue?vue&type=style&index=0&id=136ba2c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports